import * as Constants from "../../utils/Constants";

const IMAGE_URL = "/api/review/image?boxBarcode=";
const LABBEL_URL = "/api/review/label?boxBarcode=";
const ACK_MSG_URL = "/api/messageHub/ack?messageId=";

export const BoxImageURL = (barcode: string | null): string | boolean => {
  return !!barcode && Constants.API_PATH + IMAGE_URL + barcode;
};

export const BoxLabelURL = (barcode: string): string | boolean => {
  return !!barcode && Constants.API_PATH + LABBEL_URL + barcode;
};

export const BoxValidationMsgAckURL = (messageId: string | null): string | boolean => {
  return !!messageId && Constants.API_PATH + ACK_MSG_URL + messageId;
};
